/**
 * Swagger Interface
 * 数据交换格式: JSON
 *
 * OpenAPI spec version: v2.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import ajax, { AjaxPromise, ExtraFetchParams } from '@ajax';
import * as models from '../model/models';

/* tslint:disable:no-unused-variable member-ordering object-literal-shorthand */

/**
 * @description classifyArticleAddUsingPost参数
 * @property `articleId` 文章id
 * @property `classifyId` 分类id
 */
export interface ParamsclassifyArticleAddUsingPost {
  // queryParams
  /**
   * 文章id
   */
  articleId: number;
  /**
   * 分类id
   */
  classifyId: number;
}
/**
 * @description classifyArticleDeleteUsingDelete参数
 * @property `ArticleClassifyRelationId` 文章分类关系id
 */
export interface ParamsclassifyArticleDeleteUsingDelete {
  // queryParams
  /**
   * 文章分类关系id
   */
  ArticleClassifyRelationId: number;
}
/**
 * changeClassifyInfo
 */
export type ParamsBodyclassifyArticleUpdateUsingPost = models.ChangeClassifyInfo;
/**
 * @description classifyBaseAddUsingPost参数
 * @property `classifyName` 分类名称
 * @property `description` 分类简介
 */
export interface ParamsclassifyBaseAddUsingPost {
  // queryParams
  /**
   * 分类名称
   */
  classifyName: string;
  /**
   * 分类简介
   */
  description: string;
}
/**
 * @description classifyBaseDeleteUsingDelete参数
 * @property `classifyIds` 分类id列表，多个用,隔开
 */
export interface ParamsclassifyBaseDeleteUsingDelete {
  // queryParams
  /**
   * 分类id列表，多个用,隔开
   */
  classifyIds: Array<number>;
}
/**
 * @description classifyBaseUpdateClassifyIdUsingPut参数
 * @property `classifyId` 分类id
 * @property `classifyName` 分类名称
 * @property `description` 分类简介
 */
export interface ParamsclassifyBaseUpdateClassifyIdUsingPut {
  // pathParams
  /**
   * 分类id
   */
  classifyId: number;
  // queryParams
  /**
   * 分类名称
   */
  classifyName: string;
  /**
   * 分类简介
   */
  description: string;
}
/**
 * @description classifyManagerAddUsingPost参数
 * @property `manager` 管理员username
 * @property `teamId` 团队id
 */
export interface ParamsclassifyManagerAddUsingPost {
  // queryParams
  /**
   * 管理员username
   */
  manager: string;
  /**
   * 团队id
   */
  teamId: number;
}
/**
 * @description classifyManagerDeleteUsingDelete参数
 * @property `teamManagerRelationIds` 团队管理员关系id列表，多个用,隔开
 */
export interface ParamsclassifyManagerDeleteUsingDelete {
  // queryParams
  /**
   * 团队管理员关系id列表，多个用,隔开
   */
  teamManagerRelationIds: Array<number>;
}
/**
 * @description classifySearchArticleUsingGet参数
 * @property `[author]` 作者邮箱前缀
 * @property `[pageNum]` 当前页码
 * @property `[pageSize]` 每页条数
 * @property `[title]` 文章标题
 */
export interface ParamsclassifySearchArticleUsingGet {
  // queryParams
  /**
   * 作者邮箱前缀
   */
  author?: string;
  /**
   * 当前页码
   */
  pageNum?: number;
  /**
   * 每页条数
   */
  pageSize?: number;
  /**
   * 文章标题
   */
  title?: string;
}
/**
 * @description classifySpecificClassificationUsingGet参数
 * @property `classifyId` 分类id
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 */
export interface ParamsclassifySpecificClassificationUsingGet {
  // queryParams
  /**
   * 分类id
   */
  classifyId: number;
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
}
/**
 * @description classifySpecificTagUsingGet参数
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 * @property `tagId` 标签id
 */
export interface ParamsclassifySpecificTagUsingGet {
  // queryParams
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
  /**
   * 标签id
   */
  tagId: number;
}
/**
 * @description classifyTagAddUsingPost参数
 * @property `classifyId` 分类id
 * @property `tagIds` 标签ids
 */
export interface ParamsclassifyTagAddUsingPost {
  // queryParams
  /**
   * 分类id
   */
  classifyId: number;
  /**
   * 标签ids
   */
  tagIds: Array<number>;
}
/**
 * @description classifyTagDeleteUsingDelete参数
 * @property `classifyTagRelationIds` 分类标签关系id列表，多个用,隔开
 */
export interface ParamsclassifyTagDeleteUsingDelete {
  // queryParams
  /**
   * 分类标签关系id列表，多个用,隔开
   */
  classifyTagRelationIds: Array<number>;
}
/**
 * @description classifyTagSuggestUsingGet参数
 * @property `tagIds` 标签列表ids
 */
export interface ParamsclassifyTagSuggestUsingGet {
  // queryParams
  /**
   * 标签列表ids
   */
  tagIds: Array<number>;
}
export class ClassifyApi {
  protected $basePath = '/community/be'.replace(/\/$/, '');

  public constructor(basePath?: string) {
    if (basePath !== undefined) {
      this.$basePath = basePath.replace(/\/$/, '');
    }
  }

  /**
   * 
   * @summary 已发布文章进行分类
   * @param params ParamsclassifyArticleAddUsingPost
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public classifyArticleAddUsingPost = (
    params: ParamsclassifyArticleAddUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/classify/article/add';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('articleId' in params) p.query.articleId = params.articleId;
    ajax.check(params.articleId, 'articleId');
    if ('classifyId' in params) p.query.classifyId = params.classifyId;
    ajax.check(params.classifyId, 'classifyId');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 已发布文章删除分类
   * @param params ParamsclassifyArticleDeleteUsingDelete
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public classifyArticleDeleteUsingDelete = (
    params: ParamsclassifyArticleDeleteUsingDelete,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/classify/article/delete';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('ArticleClassifyRelationId' in params)
      p.query.ArticleClassifyRelationId = params.ArticleClassifyRelationId;
    ajax.check(params.ArticleClassifyRelationId, 'ArticleClassifyRelationId');
    return ajax.ajax(
      {
        ...opt,
        method: 'DELETE',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 文章改分类
   
   * @param data: ParamsBodyclassifyArticleUpdateUsingPost// changeClassifyInfo
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public classifyArticleUpdateUsingPost = (
    data: ParamsBodyclassifyArticleUpdateUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/classify/article/update';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    ajax.check(data, 'body.changeClassifyInfo');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 新增分类
   * @param params ParamsclassifyBaseAddUsingPost
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public classifyBaseAddUsingPost = (
    params: ParamsclassifyBaseAddUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/classify/base/add';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('classifyName' in params) p.query.classifyName = params.classifyName;
    ajax.check(params.classifyName, 'classifyName');
    if ('description' in params) p.query.description = params.description;
    ajax.check(params.description, 'description');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 分类列表
   
   
   * @param opt ajax config
   * @returns models.CommonResultListClassifyInfo
   */
  public classifyBaseAllUsingGet = (
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultListClassifyInfo> => {
    const path = '/api/classify/base/all';
    const url = this.$basePath + path;
    const p: any = {};
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 批量删除分类
   * @param params ParamsclassifyBaseDeleteUsingDelete
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public classifyBaseDeleteUsingDelete = (
    params: ParamsclassifyBaseDeleteUsingDelete,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/classify/base/delete';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('classifyIds' in params) p.query.classifyIds = params.classifyIds;
    ajax.check(params.classifyIds, 'classifyIds');
    return ajax.ajax(
      {
        ...opt,
        method: 'DELETE',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 超管手动初始化新增分类
   
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public classifyBaseInitUsingPost = (opt?: ExtraFetchParams): AjaxPromise<models.CommonResult> => {
    const path = '/api/classify/base/init';
    const url = this.$basePath + path;
    const p: any = {};
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 更新分类
   * @param params ParamsclassifyBaseUpdateClassifyIdUsingPut
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public classifyBaseUpdateClassifyIdUsingPut = (
    params: ParamsclassifyBaseUpdateClassifyIdUsingPut,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/classify/base/update/{classifyId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('classifyName' in params) p.query.classifyName = params.classifyName;
    ajax.check(params.classifyName, 'classifyName');
    if ('description' in params) p.query.description = params.description;
    ajax.check(params.description, 'description');
    ajax.check(params.classifyId, 'classifyId');
    return ajax.ajax(
      {
        ...opt,
        method: 'PUT',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 新增团队管理员关系
   * @param params ParamsclassifyManagerAddUsingPost
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public classifyManagerAddUsingPost = (
    params: ParamsclassifyManagerAddUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/classify/manager/add';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('manager' in params) p.query.manager = params.manager;
    ajax.check(params.manager, 'manager');
    if ('teamId' in params) p.query.teamId = params.teamId;
    ajax.check(params.teamId, 'teamId');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 批量删除团队管理员关系
   * @param params ParamsclassifyManagerDeleteUsingDelete
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public classifyManagerDeleteUsingDelete = (
    params: ParamsclassifyManagerDeleteUsingDelete,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/classify/manager/delete';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('teamManagerRelationIds' in params)
      p.query.teamManagerRelationIds = params.teamManagerRelationIds;
    ajax.check(params.teamManagerRelationIds, 'teamManagerRelationIds');
    return ajax.ajax(
      {
        ...opt,
        method: 'DELETE',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 分类搜索文章-已发布文章分类列表
   * @param params ParamsclassifySearchArticleUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultArticleLatestVO
   */
  public classifySearchArticleUsingGet = (
    params: ParamsclassifySearchArticleUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultArticleLatestVO> => {
    const path = '/api/classify/search/article';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('author' in params) p.query.author = params.author;
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    if ('title' in params) p.query.title = params.title;
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 查询特定分类的标签
   * @param params ParamsclassifySpecificClassificationUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResult
   */
  public classifySpecificClassificationUsingGet = (
    params: ParamsclassifySpecificClassificationUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResult> => {
    const path = '/api/classify/specific/classification';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('classifyId' in params) p.query.classifyId = params.classifyId;
    ajax.check(params.classifyId, 'classifyId');
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 查询特定标签的分类
   * @param params ParamsclassifySpecificTagUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResult
   */
  public classifySpecificTagUsingGet = (
    params: ParamsclassifySpecificTagUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResult> => {
    const path = '/api/classify/specific/tag';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    if ('tagId' in params) p.query.tagId = params.tagId;
    ajax.check(params.tagId, 'tagId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 新增分类标签映射关系
   * @param params ParamsclassifyTagAddUsingPost
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public classifyTagAddUsingPost = (
    params: ParamsclassifyTagAddUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/classify/tag/add';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('classifyId' in params) p.query.classifyId = params.classifyId;
    ajax.check(params.classifyId, 'classifyId');
    if ('tagIds' in params) p.query.tagIds = params.tagIds;
    ajax.check(params.tagIds, 'tagIds');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 批量删除分类标签映射关系
   * @param params ParamsclassifyTagDeleteUsingDelete
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public classifyTagDeleteUsingDelete = (
    params: ParamsclassifyTagDeleteUsingDelete,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/classify/tag/delete';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('classifyTagRelationIds' in params)
      p.query.classifyTagRelationIds = params.classifyTagRelationIds;
    ajax.check(params.classifyTagRelationIds, 'classifyTagRelationIds');
    return ajax.ajax(
      {
        ...opt,
        method: 'DELETE',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 根据多个标签推荐分类，无标签则返回所有分类列表
   * @param params ParamsclassifyTagSuggestUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultListClassifyInfo
   */
  public classifyTagSuggestUsingGet = (
    params: ParamsclassifyTagSuggestUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultListClassifyInfo> => {
    const path = '/api/classify/tag/suggest';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('tagIds' in params) p.query.tagIds = params.tagIds;
    ajax.check(params.tagIds, 'tagIds');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
}

export default new ClassifyApi();
